// extracted by mini-css-extract-plugin
export default {"card":"taskInput_card__k3Wt5"};